import React, { useEffect } from 'react';
import 'react-phone-input-2/lib/style.css';
import { Typography, Box, Divider } from '@mui/material';
import DynamicForm from '../../../commun/DynamicForm';
import './TalentForm.css'; 

function TalentForm({ goToNextStep, formData, setFormData, errors, setErrors }) {

  const generateTrigramme = (prenom, nom) => {
    if (!prenom || !nom) return '';
    const firstLetterPrenom = prenom.trim().charAt(0).toUpperCase();
    const firstLetterNom = nom.trim().charAt(0).toUpperCase();
    const lastLetterNom = nom.trim().slice(-1).toUpperCase();
    return `${firstLetterPrenom}${firstLetterNom}${lastLetterNom}`;
  };

  useEffect(() => {
    if (formData.prenomCandidat && formData.nomCandidat) {
      const trigram = generateTrigramme(formData.prenomCandidat, formData.nomCandidat);
      setFormData(prev => ({ ...prev, trigramme: trigram }));
    }
  }, [formData.prenomCandidat, formData.nomCandidat, setFormData]);

  const validateFields = () => {
    const requiredFields = ['nomCandidat', 'prenomCandidat', 'cvUpload'];
    const newErrors = {};

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = 'Veuillez remplir ce champ';
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNextStep = () => {
    if (validateFields()) {
      const { nomCandidat, prenomCandidat, trigramme } = formData;
      const trigram = (!trigramme || trigramme.trim() === '')
        ? generateTrigramme(prenomCandidat, nomCandidat)
        : trigramme;

      setFormData(prev => ({ ...prev, trigramme: trigram }));
      goToNextStep();
    }
  };

  const step1Config = [
    { label: "Nom", name: "nomCandidat", type: "text", required: true },
    { label: "Prénom", name: "prenomCandidat", type: "text", required: true },
    { label: "Trigramme", name: "trigramme", type: "text", readOnly: true }, 
    { label: "Email", name: "email", type: "chip", required: true },
    { label: "Téléphones", name: "phone", type: "chip-phone", required: true },
    { label: "LinkedIn", name: "LinkedIn", type: "text" },
    { label: "Autres liens", name: "autresLiens", type: "chip" },
    { label: "CV", name: "cvUpload", type: "file", required: true, showFileName: true },
    { label: "Autre document", name: "AutreDocument", type: "file" },
  ];

  return (
    <Box className="talent-form-container">
      <Typography variant="h6" className="form-title">
        Informations du candidat
      </Typography>
      <Divider className="form-divider" />
      <DynamicForm
        fields={step1Config}
        formData={formData}
        setFormData={setFormData}
        errors={errors}
        setErrors={setErrors}
        onNext={handleNextStep}
      />
    </Box>
  );
}

export default TalentForm;
